import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const getPublicInfo = async (id) => {
  return await httpClient.get(`/announcement_public/${id}/`);
};

const getPublicRoles = async (id) => {
  return await httpClient.get(
    `/announcement_rol_public/?filter[convocatoria]=${id}`,
  );
};

const getPublicAnexoUrl = async (id) => {
  return await httpClient.get(`/announcement_public/${id}/annex/`);
};

const get = async (id, preview = false) => {
  return await httpClient.get(
    `/${preview ? 'announcement_preview' : 'announcement_contractor'}/${id}/`,
  );
};

const getAnexoUrl = async (id, preview = false) => {
  return await httpClient.get(
    `/${preview ? 'announcement_preview' : 'announcement_contractor'}/${id}/annex/`,
  );
};

// TODO: Change to ajaxtable
const filter = async (query = '') => {
  return await httpClient.get(`/announcement_contractor${query}`);
};

const applyToRole = async (id, data) => {
  return await httpClient.put(
    `/announcement_rol_contractor/${id}/apply/`,
    data,
  );
};

const reject = async (id, data) => {
  return await httpClient.put(`/announcement_contractor/${id}/reject/`, data);
};

// TODO: Check uses
const getRoles = async (query, preview = false) => {
  return await httpClient.get(
    `/${preview ? 'announcement_rol_preview' : 'announcement_rol_contractor'}${query}`,
  );
};

const getAdjustInfo = async (id) => {
  return await httpClient.get(
    `/announcement_rol_contractor/${id}/get_adjust_info/`,
  );
};

const notify = async (id, transactionType) => {
  return await httpClient.post(`/announcement_rol_contractor/${id}/notify/`, {
    tipo: transactionType,
  });
};

export {
  getPublicInfo,
  getPublicRoles,
  getPublicAnexoUrl,
  get,
  getAnexoUrl,
  filter,
  applyToRole,
  reject,
  getAdjustInfo,
  notify,
  getRoles,
};
